import React from 'react'
import { motion } from 'framer-motion'

const fadeInAnimationVariant = {
    initial: {
        opacity: 0,
        translateX: '-100%',
    },
    animate: (index) => ({
        opacity: 1,
        translateX: 0,
        transition: {
            delay: 0.25 * index,
            ease: 'easeIn'
        }
    })
}

function TypeBadge({types}) {
    return (
        <div className='flex flex-row gap-x-2'>
            {types.map((type, index) => {
                return (
                    <motion.div
                    key={index}
                    variants={fadeInAnimationVariant}
                    initial="initial"
                    whileInView="animate"
                    viewport={{
                        once: true,
                    }}
                    custom={index}
                     className={`text-[10px] px-4 py-1 uppercase text-white font-bold rounded-full tracking-wide bg-pokemonType-${type}`}>{type}</motion.div>
                )
            })}
    </div>
    )
}

export default TypeBadge